module.exports = __webpack_public_path__ + "static/media/mindfulness-for-sleep@2x.acb6a763.png";